import React, { FC, memo } from 'react';
import _map from 'lodash/map';
import FormikSelectableSearchDropdown from '@minecraft.formik-selectable-search-dropdown';
import { useSubmissionStatusOptions } from '@blocs.filter';
import { FilterData } from '../../shared/types';
import { Label, StyledFormikSelectableSearchDropdown } from '../../shared/styles';

type Props = FilterData;

const SubmissionStatus: FC<Props> = ({ name, label }) => {
  const submissionStatusOptions = useSubmissionStatusOptions();

  return (
    <>
      <Label>{label}</Label>
      <StyledFormikSelectableSearchDropdown saveAsOption name={name}>
        {_map(submissionStatusOptions, (option) => (
          <FormikSelectableSearchDropdown.Option key={option.value} label={option.label} value={option.value} />
        ))}
      </StyledFormikSelectableSearchDropdown>
    </>
  );
};

export default memo(SubmissionStatus);
